<template>
  <iframe
    v-if="!urlLoading"
    :height="iframeHeight"
    width="100%"
    allowfullscreen
    scrolling="no"
    :src="src"
  />

  <UProgressBar
    v-if="loading"
    green
    is-loader
  />
</template>

<script setup>
import { onMounted, ref } from "vue";

import AxiosController from "@/api/axiosController";
const axiosController = new AxiosController();

const urlLoading = ref(true);
const loading = ref(true);
const src = ref("");
const iframeHeight = ref("0px");

const props = defineProps({
  currency: {
    type: String,
    default: ""
  }
});

onMounted(async () => {
  const params = await axiosController.getOAuthParams("rwa-exchange");

  src.value = `${params.redirect_url}?token=${params.token}&refreshToken=${params.refresh_token}&currency=${props.currency}`;

  urlLoading.value = false;

  window.addEventListener("message", function (e) {
    if (!src.value.startsWith(e.origin)) {
      return;
    }

    loading.value = false;

    if (e.data && e.data.height) {
      iframeHeight.value = `${e.data.height}px`;
    }
  });
});
</script>